import React, { useState } from 'react';

const Portfolio: React.FC = () => {
  const [activeFilter, setActiveFilter] = useState('all');

  const projects = [
    {
      id: 1,
      title: "Bitko Social Media Campaign",
      category: "social",
      description: "Complete social media poster series for Bitko brand, featuring modern design and engaging visuals.",
      image: "/images/bitko/BITKO AUG-04.jpg",
      tags: ["Social Media", "Poster Design", "Brand Campaign"]
    },
    {
      id: 5,
      title: "Bitko August Series",
      category: "social",
      description: "August campaign series for Bitko featuring multiple poster designs for social media platforms.",
      image: "/images/bitko/BITKO AUG-06.jpg",
      tags: ["Social Media", "Campaign Series", "Poster Design"]
    },
    {
      id: 7,
      title: "Bitko Additional Designs",
      category: "social",
      description: "Additional social media poster designs for Bitko brand with creative layouts and engaging content.",
      image: "/images/bitko/BITKO AUG-07.jpg",
      tags: ["Social Media", "Poster Design", "Creative Layout"]
    },
    {
      id: 10,
      title: "Raafort Complete Series",
      category: "social",
      description: "Complete social media poster series for Raafort brand with comprehensive marketing materials.",
      image: "/images/raafort/RAAFORT JULY-01.jpg",
      tags: ["Social Media", "Complete Series", "Marketing Materials"]
    },
    {
      id: 11,
      title: "Raafort July Campaign",
      category: "social",
      description: "July campaign series for Raafort brand with professional marketing posters.",
      image: "/images/raafort/RAAFORT JULY-05.jpg",
      tags: ["Social Media", "July Campaign", "Professional Design"]
    },
    {
      id: 12,
      title: "Raafort Marketing Series",
      category: "social",
      description: "Marketing poster series for Raafort brand showcasing product features and benefits.",
      image: "/images/raafort/RAAFORT JULY-06.jpg",
      tags: ["Social Media", "Marketing Series", "Product Features"]
    },
    {
      id: 15,
      title: "Karaama August Series",
      category: "social",
      description: "August series for Karaama brand with vibrant colors and creative layouts.",
      image: "/images/karaama/KARAAMA AUG-05.jpg",
      tags: ["Social Media", "August Series", "Vibrant Colors"]
    },
    {
      id: 16,
      title: "Karaama Creative Campaign",
      category: "social",
      description: "Creative campaign for Karaama brand with innovative design concepts.",
      image: "/images/karaama/KARAAMA AUG-12.jpg",
      tags: ["Social Media", "Creative Campaign", "Innovative Design"]
    },
    {
      id: 17,
      title: "Karaama Extended Series",
      category: "social",
      description: "Extended series for Karaama brand with diverse poster designs and styles.",
      image: "/images/karaama/KARAAMA AUG-13.jpg",
      tags: ["Social Media", "Extended Series", "Diverse Design"]
    },
    {
      id: 18,
      title: "Karaama Final Collection",
      category: "social",
      description: "Final collection for Karaama brand with comprehensive social media materials.",
      image: "/images/karaama/KARAAMA AUG-18.jpg",
      tags: ["Social Media", "Final Collection", "Comprehensive Materials"]
    },
    {
      id: 19,
      title: "Bitko August Launch",
      category: "social",
      description: "August launch campaign for Bitko brand with engaging social media posters.",
      image: "/images/bitko/BITKO AUG-01.jpg",
      tags: ["Social Media", "August Launch", "Engaging Design"]
    },
    {
      id: 20,
      title: "Bitko Creative Series",
      category: "social",
      description: "Creative series for Bitko brand with innovative design concepts and modern aesthetics.",
      image: "/images/bitko/BITKO AUG-03.jpg",
      tags: ["Social Media", "Creative Series", "Innovative Design"]
    },
    {
      id: 21,
      title: "Bitko Premium Collection",
      category: "social",
      description: "Premium collection for Bitko brand with high-quality social media marketing materials.",
      image: "/images/bitko/BITKO AUG-05.jpg",
      tags: ["Social Media", "Premium Collection", "High-Quality Design"]
    },
    {
      id: 22,
      title: "Raafort August Launch",
      category: "social",
      description: "August launch campaign for Raafort brand with engaging social media posters.",
      image: "/images/raafort/RAAFORT AUG-01.jpg",
      tags: ["Social Media", "August Launch", "Engaging Design"]
    },
    {
      id: 23,
      title: "Raafort Creative Series",
      category: "social",
      description: "Creative series for Raafort brand with innovative design concepts and modern aesthetics.",
      image: "/images/raafort/RAAFORT AUG-02.jpg",
      tags: ["Social Media", "Creative Series", "Innovative Design"]
    },
    {
      id: 24,
      title: "Raafort Advanced Collection",
      category: "social",
      description: "Advanced collection for Raafort brand with sophisticated social media marketing materials.",
      image: "/images/raafort/RAAFORT AUG-05.jpg",
      tags: ["Social Media", "Advanced Collection", "Sophisticated Design"]
    },
    {
      id: 25,
      title: "Logo Design Collection 1",
      category: "Logo",
      description: "Professional logo design with modern typography and clean aesthetics.",
      image: "/images/logos/Logos-01.jpg",
      tags: ["Logo Design", "Typography", "Brand Identity"]
    },
    {
      id: 26,
      title: "Logo Design Collection 2",
      category: "Logo",
      description: "Creative logo design featuring innovative visual elements and brand recognition.",
      image: "/images/logos/Logos-02.jpg",
      tags: ["Logo Design", "Creative", "Brand Recognition"]
    },
    {
      id: 27,
      title: "Logo Design Collection 3",
      category: "Logo",
      description: "Modern logo design with sophisticated color schemes and professional appeal.",
      image: "/images/logos/Logos-03.jpg",
      tags: ["Logo Design", "Modern", "Professional"]
    },
    {
      id: 28,
      title: "Logo Design Collection 4",
      category: "Logo",
      description: "Elegant logo design showcasing refined typography and visual balance.",
      image: "/images/logos/Logos-04.jpg",
      tags: ["Logo Design", "Elegant", "Typography"]
    },
    {
      id: 29,
      title: "Logo Design Collection 5",
      category: "Logo",
      description: "Bold logo design with striking visual impact and memorable brand presence.",
      image: "/images/logos/Logos-05.jpg",
      tags: ["Logo Design", "Bold", "Memorable"]
    },
    {
      id: 30,
      title: "Logo Design Collection 6",
      category: "Logo",
      description: "Minimalist logo design emphasizing simplicity and timeless appeal.",
      image: "/images/logos/Logos-06.jpg",
      tags: ["Logo Design", "Minimalist", "Timeless"]
    },
    {
      id: 31,
      title: "Logo Design Collection 7",
      category: "Logo",
      description: "Dynamic logo design with contemporary elements and visual energy.",
      image: "/images/logos/Logos-07.jpg",
      tags: ["Logo Design", "Dynamic", "Contemporary"]
    },
    {
      id: 32,
      title: "Logo Design Collection 8",
      category: "Logo",
      description: "Professional logo design with corporate appeal and brand authority.",
      image: "/images/logos/Logos-08.jpg",
      tags: ["Logo Design", "Professional", "Corporate"]
    },
    {
      id: 33,
      title: "Logo Design Collection 9",
      category: "Logo",
      description: "Creative logo design featuring unique visual concepts and brand personality.",
      image: "/images/logos/Logos-09.jpg",
      tags: ["Logo Design", "Creative", "Brand Personality"]
    },
    {
      id: 34,
      title: "Logo Design Collection 10",
      category: "Logo",
      description: "Premium logo design with sophisticated aesthetics and brand excellence.",
      image: "/images/logos/Logos-10.jpg",
      tags: ["Logo Design", "Premium", "Brand Excellence"]
    },
    {
      id: 35,
      title: "Event Photography 01",
      category: "events",
      description: "Professional event photography capturing memorable moments and experiences.",
      image: "/images/events/Events-01.jpg",
      tags: ["Event Photography", "Professional", "Memorable Moments"]
    },
    {
      id: 36,
      title: "Event Photography 02",
      category: "events",
      description: "High-quality event documentation showcasing professional photography skills.",
      image: "/images/events/Events-02.jpg",
      tags: ["Event Photography", "Documentation", "Professional Quality"]
    }
  ];

  const filters = [
    { key: 'all', label: 'All Projects' },
    { key: 'Logo', label: 'Logo design' },
    { key: 'social', label: 'Social Media' },
    { key: 'events', label: 'Events' }
  ];

  const filteredProjects = activeFilter === 'all' 
    ? projects 
    : projects.filter(project => project.category === activeFilter);

  return (
    <main className="pt-20 sm:pt-24">
      {/* Hero Section */}
      <section className="section-padding bg-white">
        <div className="container-custom text-center">
          <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium text-gray-900 mb-4 sm:mb-6">
            Our Portfolio
          </h1>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 max-w-3xl mx-auto px-4">
            Showcasing our best work and creative solutions that have helped businesses grow and succeed
          </p>
        </div>
      </section>

      {/* Filter Section */}
      <section className="section-padding bg-white">
        <div className="container-custom">
          <div className="flex flex-wrap justify-center gap-2 sm:gap-4 mb-8 sm:mb-12 px-4">
            {filters.map((filter) => (
              <button
                key={filter.key}
                onClick={() => setActiveFilter(filter.key)}
                className={`px-4 sm:px-6 py-2 sm:py-3 rounded-full font-normal transition-all duration-300 text-sm sm:text-base ${
                  activeFilter === filter.key
                    ? 'bg-brand-orange text-white shadow-lg'
                    : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                }`}
              >
                {filter.label}
              </button>
            ))}
          </div>

          {/* Projects Grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8">
            {filteredProjects.map((project) => (
              <div key={project.id} className="group bg-white rounded-xl sm:rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2">
                <div className="h-64 sm:h-80 md:h-96 relative overflow-hidden">
                  <img 
                    src={project.image} 
                    alt={project.title}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                    onError={(e) => {
                      // Fallback to placeholder if image fails to load
                      const target = e.target as HTMLImageElement;
                      target.style.display = 'none';
                      const parent = target.parentElement;
                      if (parent) {
                        parent.innerHTML = `
                          <div class="w-full h-full bg-gradient-to-br from-brand-blue to-brand-orange flex items-center justify-center">
                            <div class="text-center text-white">
                              <svg class="w-12 h-12 sm:w-16 sm:h-16 mx-auto mb-2 opacity-80" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
                              </svg>
                              <span class="text-xs sm:text-sm font-normal">${project.title}</span>
                            </div>
                          </div>
                        `;
                      }
                    }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding bg-gray-50">
        <div className="container-custom text-center">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-medium text-gray-900 mb-4 sm:mb-6">
            Ready to Start Your Project?
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 mb-6 sm:mb-8 max-w-2xl mx-auto px-4">
            Let's create something amazing together. Get in touch to discuss your project.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center px-4">
            <button 
              onClick={() => window.location.href = '#contact'}
              className="bg-brand-blue text-white px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-normal hover:bg-brand-orange transition-all duration-300 text-sm sm:text-base"
            >
              Start Your Project
            </button>
            <button 
              onClick={() => window.location.href = '#portfolio'}
              className="bg-white text-brand-blue border-2 border-brand-blue px-6 sm:px-8 py-2 sm:py-3 rounded-lg font-normal hover:bg-brand-blue hover:text-white transition-all duration-300 text-sm sm:text-base"
            >
              View More Work
            </button>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Portfolio;
